import { action, computed, observable } from 'mobx';
import api from 'core/util/api';

const SEARCH_API_BASE = '/api/ui/search';

class SearchStore {
  @observable searchLoading = {
    db: false,
    uiSiteBasic: false,
    uiSiteAi: false
  };

  @observable.ref results = {
    dbModels: [],
    uiSiteBasic: [],
    uiSiteAi: [],
  }

  @observable queryString = '';


  formatQueryString(queryString) {
    return encodeURIComponent(queryString.replace(/\s+/g, ' '));
  }

  flattenResults(results) {
    const newResults = [];

    Object.keys(results).forEach((key) => {
      if (Array.isArray(results[key])) {
        if (key === 'costGroups' && this.store.$cost.canViewCosts) {
          newResults.push(
            ...results[key].map((resultRow) => ({
              category: key,
              ...resultRow
            }))
          );
        } else {
          newResults.push(
            ...results[key].map((resultRow) => ({
              category: key,
              ...resultRow
            }))
          );
        }
      }
    });

    return newResults;
  }

  @computed
  get totalResults() {
    const items = this.results.dbModels ? Object.keys(this.results.dbModels) : [];

    return items.reduce(
      (total, item) => total + (Array.isArray(this.results.dbModels[item]) ? this.results.dbModels[item].length : 0),
      0
    );
  }

  getSortedResults(results) {
    return this.flattenResults(results).sort((rowA, rowB) => {
      if (!rowA.score || !rowB.score) {
        return 0; // Keep original order if no score
      } else {
        return rowA.score < rowB.score ? 1 : -1;
      }
    });
  }

  @action
  queryDB(queryString) {
    this.searchLoading.db = true;
    this.queryString = queryString;

    return api.get(`${SEARCH_API_BASE}?q=${this.formatQueryString(queryString)}`).then(
      (response) => {
        this.searchLoading.db = false;
        this.results.dbModels = response;

        return response;
      },
      () => {
        this.searchLoading.db = false;
        this.results.dbModels = [];
      }
    );
  }

  @action
  queryUiSite(queryString, type, path) {
    this.searchLoading[type] = true;
    this.queryString = queryString;

    return api.get(`${SEARCH_API_BASE}/${path}?q=${this.formatQueryString(queryString)}`)
      .then((response) => {
        this.searchLoading[type] = false;
        this.results[type] = response;

        return { navigation: response };
      },
        () => {
          this.searchLoading[type] = false;
        }
      );
  }

  @action
  queryUiSiteBasic(queryString) {
    this.searchLoading.uiSiteBasic = true;
    this.queryString = queryString;

    return api.get(`${SEARCH_API_BASE}/basic-site-search?q=${this.formatQueryString(queryString)}`).then(
      (response) => {
        this.searchLoading.uiSiteBasic = false;

        this.results.uiSiteBasic = response;

        return { navigation: response };
      },
      () => {
        this.searchLoading.uiSiteBasic = false;
      }
    );
  }

  @action
  queryUiSiteAi(queryString) {
    this.searchLoading.uiSiteAi = true;
    this.queryString = queryString;

    return api.get(`${SEARCH_API_BASE}/ai-site-search?q=${this.formatQueryString(queryString)}`).then(
      (response) => {
        this.searchLoading.uiSiteAi = false;
        this.results.uiSiteAi = response;

        return { navigation: response };
      },
      () => {
        this.searchLoading.uiSiteAi = false;
      }
    );
  }

  @action
  clearResults() {
    this.results = {
      dbModels: [],
      uiSiteBasic: [],
      uiSiteAi: [],
    };
  }
}

export default new SearchStore();
